export default class Pagination {

  constructor(args) {
    this.container = $(args['container']);
    this.postType = args['postType'];
    this.postsPerPage = args['postsPerPage'];
    this.page = args['page'];
    this.onUpdate = args['onUpdate'];
    this.beforeLoad = args['beforeLoad'];
    this.onPageChange = args['onPageChange'];
    this.taxonomies = args['taxonomies'];
    this.pageCount = 10;

    this.init();
  }

  init() {
    this.addEventlisteners();
    var that = this;

    $('.c-pagination__nav-button--next').click(function() {
      if (that.pageCount > that.page) {
        that.page++;
        that.getPosts(that.page);
        $('.c-pagination__page').removeClass('c-pagination__page--active');
        $('.c-pagination__page[data-page=' + that.page + ']').addClass('c-pagination__page--active');
        if (that.onPageChange) {
          that.onPageChange();
        }
      }
    });

    $('.c-pagination__nav-button--prev').click(function() {
      if (that.page > 1) {
        that.page--;
        that.getPosts(that.page);
        $('.c-pagination__page').removeClass('c-pagination__page--active');
        $('.c-pagination__page[data-page=' + that.page + ']').addClass('c-pagination__page--active');
        if (that.onPageChange) {
          that.onPageChange();
        }
      }
    });
  }

  addEventlisteners() {
    var that = this;
    $('.c-pagination__page').click(function() {
      that.page = $(this).attr('data-page');
      that.getPosts(that.page);
      $('.c-pagination__page').removeClass('c-pagination__page--active');
      $(this).addClass('c-pagination__page--active');
      if (that.onPageChange) {
        that.onPageChange();
      }
    });
  }

  getPosts(page, taxonomies) {
    if (this.beforeLoad) {
      this.beforeLoad();
    }

    if (taxonomies) {
      this.taxonomies = taxonomies;
    }

    var that = this;
    const data = null;
    const sendData = Object.assign( {
      'dataType': 'json',
      'action': 'custom_get_posts',
      'type': this.postType,
      'taxonomies': this.taxonomies,
      'count': this.postsPerPage,
      'page': page,
    }, data);
    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: function (response) {
        let responseArray = JSON.parse(response);
        let currentPage = parseInt(responseArray['current_page']);
        let pageCount = parseInt(responseArray['page_count']);

        if (currentPage && pageCount) {
          that.page = currentPage;
          that.pageCount = pageCount;
          that.updateNavigation(currentPage, pageCount);
        }

        that.updateURLParameter(window.location.href, ajax_args.page_parameter, that.page);
        that.onUpdate(responseArray);
      },
      error: function (response) {
        console.log(response);
      },
    });
  }

  updateNavigation(currentPage, pageCount) {
    if (pageCount > 1) {
      var list = $($('.c-pagination__pages').first());
      list.html('');
      var diff = Math.min(Math.max(0, currentPage - 3), Math.max(pageCount-5, 0), 0);

      for (var i = 1; i <= Math.min(pageCount, 5); i++) {
        var li = $('<li>').addClass('c-pagination__page');
        li.attr('data-page', i+diff);
        li.html(i+diff);

        if (i+diff == currentPage) {
          li.addClass('c-pagination__page--active');
        }

        list.append(li);
      }

      $(this.container.selector).show(0);
      this.addEventlisteners();
    } else {
      $(this.container.selector).hide(0);
    }
  }

  updateURLParameter(url, param, paramVal) {
      let newAdditionalURL = '';
      let tempArray = url.split('?');
      const baseURL = tempArray[0];
      const additionalURL = tempArray[1];
      let temp = '';

      if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (var i = 0; i < tempArray.length; i++) {
          if(tempArray[i].split('=')[0] != param) {
              newAdditionalURL += temp + tempArray[i];
              temp = '&';
          }
        }
      }

      const rows_txt = temp + '' + param + '=' + paramVal;
      const res = baseURL + '?' + newAdditionalURL + rows_txt;
      window.history.replaceState('', '', res);
    }
}



// WEBPACK FOOTER //
// ./scripts/components/pagination.js